var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _circle, _ellipse, _ellipse2, _ellipse3, _ellipse4, _ellipse5, _ellipse6, _ellipse7;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVerticalDivider(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 182,
    viewBox: "0 0 17 182",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15 2L3 14L15 26",
    stroke: "#131673",
    strokeWidth: 3
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15 24L3 36L15 48",
    stroke: "#131673",
    strokeWidth: 3
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15 46L3 58L15 70",
    stroke: "#131673",
    strokeWidth: 3
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M15 68L3 80L15 92",
    stroke: "#131673",
    strokeWidth: 3
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M15 90L3 102L15 114",
    stroke: "#131673",
    strokeWidth: 3
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M15 112L3 124L15 136",
    stroke: "#131673",
    strokeWidth: 3
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M15 134L3 146L15 158",
    stroke: "#131673",
    strokeWidth: 3
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M15 156L3 168L15 180",
    stroke: "#131673",
    strokeWidth: 3
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 13,
    cy: 13.8428,
    r: 2,
    fill: "#FE0000"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 13,
    cy: 35.8652,
    rx: 2,
    ry: 2.02247,
    fill: "#FE0000"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 13,
    cy: 57.9102,
    rx: 2,
    ry: 2.02247,
    fill: "#FE0000"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 13,
    cy: 79.9551,
    rx: 2,
    ry: 2.02247,
    fill: "#FE0000"
  })), _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 13,
    cy: 102,
    rx: 2,
    ry: 2.02247,
    fill: "#FE0000"
  })), _ellipse5 || (_ellipse5 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 13,
    cy: 124.045,
    rx: 2,
    ry: 2.02247,
    fill: "#FE0000"
  })), _ellipse6 || (_ellipse6 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 13,
    cy: 146.09,
    rx: 2,
    ry: 2.02247,
    fill: "#FE0000"
  })), _ellipse7 || (_ellipse7 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 13,
    cy: 168.135,
    rx: 2,
    ry: 2.02247,
    fill: "#FE0000"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVerticalDivider);
export default __webpack_public_path__ + "static/media/vertical-divider.a02b475910dafc4cc2738016531ccaeb.svg";
export { ForwardRef as ReactComponent };